















import { defineComponent, PropType } from "@vue/composition-api";
import { CommentListItem } from "./types";
import Comment from "./Comment/index.vue";

export default defineComponent({
  name: "CommentList",
  components: { Comment },
  props: {
    commentList: {
      type: Object as PropType<CommentListItem>,
      required: true
    },
    userImageUrl: {
      type: String,
      required: true
    }
  },
  emits: ["delete"],
  setup(_, { emit }) {
    const handleDeletedComment = (commentId: number) => {
      emit("delete", commentId);
    };
    return {
      handleDeletedComment
    };
  }
});
